/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_List_Title1Inputs */

const vi_cmspost_list_title1 = /** @type {(inputs: Cmspost_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài viết`)
};

/**

* @param {Cmspost_List_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_list_title1 = /** @type {((inputs?: Cmspost_List_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_List_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_list_title1(inputs)
});
export { cmspost_list_title1 as "cmsPost_list_title" }